var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"list",staticClass:"list-with-scroll-overhangs",on:{"scroll":_vm.checkScrollConditions}},[(_vm.canScrollUp)?_c('div',{staticClass:"overhang top-overhang"}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.canScrollDown)?_c('div',{staticClass:"overhang bottom-overhang"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }